import { Box, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { titleTextColor } from 'assets/styles/_palette';

export const ChangePasswordModalContent = styled(Box)({
	...flexMixin({ direction: 'column' }),
	width: '100%',
	padding: '48px 64px',
});

export const Title = styled(Typography)({
	fontSize: '24px',
	fontWeight: 700,
	lineHeight: '133.4%',
	color: titleTextColor,
	margin: '32px 0 24px 0',
});

export const Form = styled(Box)({
	...flexMixin({ direction: 'column', gap: 24 }),
	width: '100%',
});
